export default __webpack_public_path__ + "static/media/5_2.88dd9607.png";